import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Relationships',
  content: `
Relationships in Pliable define how Entities are connected, reflecting the natural hierarchies and associations within your business. For example, an Order entity might relate to a Customer entity or a Product entity, establishing connections that allow data to be analyzed across multiple dimensions. By defining relationships, you unlock powerful multi-dimensional reporting capabilities, making it easy to explore and analyze data across interconnected entities in a structured and intuitive way.

# Creating a Relationship

Relationships can be created in the **Semantic Layer** by connecting two Entities together.

You can also create relationships from the sidebar in the **Node Configuration** screen.

# Relationship Configuration

## Data Connections

Relationship data connections tell Pliable how to determine if two Entities are related to each other.

For example, you may want to create a relationship between an Order and a Customer if the \`Order.Customer_Email\` is equal to the \`Customer.Email\`. Oftentimes your source data will already include ID fields that you can use in relationships, such as an \`Order.Customer_ID\` matching to a \`Customer.ID\`.

> 💡 Hint: Pliable will automatically flag Entity records that, given your data connections, can be related to more than one parent. For example, you may have duplicate Customer records with the same Email, and if you are using Email in your relationship, a single Order may point at multiple Customers. This is typically indicative of a data integrity problem, which you can solve by implementing Cleaning Rules upstream of your Entities.
`,
};

export default doc;
